import { levelConfig } from './level-config';
import { themeConfig } from './theme-config';
import { locationConfig } from './location-config';
import { fedFundingConfig } from './fed-funding-config';

export const layerConfig = [
  {
    ...themeConfig['Service Coverage 100/20'],
    ...levelConfig['Census Block'],
    visible: false,
  },
  {
    ...themeConfig['Service Coverage 25/3'],
    ...levelConfig['Census Block'],
    visible: false,
  },
  {
    ...themeConfig.Competition,
    ...levelConfig['Census Block'],
    visible: false,
  },
  {
    ...themeConfig['Number of Providers'],
    ...levelConfig['Census Block'],
    visible: false,
  },
  {
    ...themeConfig['Maximum Speed'],
    ...levelConfig['Census Block'],
    visible: false,
  },
  {
    ...themeConfig['Federal Funding'],
    ...levelConfig['Census Block'],
    visible: false,
  },

  {
    ...themeConfig['Service Coverage 100/20'],
    ...levelConfig['Census Tract'],
    visible: false,
  },
  {
    ...themeConfig['Service Coverage 25/3'],
    ...levelConfig['Census Tract'],
    visible: false,
  },
  {
    ...themeConfig.Competition,
    ...levelConfig['Census Tract'],
    visible: false,
  },
  {
    ...themeConfig['Number of Providers'],
    ...levelConfig['Census Tract'],
    visible: false,
  },
  {
    ...themeConfig['Maximum Speed'],
    ...levelConfig['Census Tract'],
    visible: false,
  },
  {
    ...themeConfig['Federal Funding'],
    ...levelConfig['Census Tract'],
    visible: false,
  },

  {
    ...themeConfig['Service Coverage 100/20'],
    ...levelConfig['MA House District'],
    visible: false,
  },
  {
    ...themeConfig['Service Coverage 25/3'],
    ...levelConfig['MA House District'],
    visible: false,
  },
  {
    ...themeConfig.Competition,
    ...levelConfig['MA House District'],
    visible: false,
  },
  {
    ...themeConfig['Number of Providers'],
    ...levelConfig['MA House District'],
    visible: false,
  },
  {
    ...themeConfig['Maximum Speed'],
    ...levelConfig['MA House District'],
    visible: false,
  },
  {
    ...themeConfig['Federal Funding'],
    ...levelConfig['MA House District'],
    visible: false,
  },

  {
    ...themeConfig['Service Coverage 100/20'],
    ...levelConfig['MA Senate District'],
    visible: false,
  },
  {
    ...themeConfig['Service Coverage 25/3'],
    ...levelConfig['MA Senate District'],
    visible: false,
  },
  {
    ...themeConfig.Competition,
    ...levelConfig['MA Senate District'],
    visible: false,
  },
  {
    ...themeConfig['Number of Providers'],
    ...levelConfig['MA Senate District'],
    visible: false,
  },
  {
    ...themeConfig['Maximum Speed'],
    ...levelConfig['MA Senate District'],
    visible: false,
  },
  {
    ...themeConfig['Federal Funding'],
    ...levelConfig['MA Senate District'],
    visible: false,
  },

  {
    ...themeConfig['Service Coverage 100/20'],
    ...levelConfig.Municipality,
    visible: true,
  },
  {
    ...themeConfig['Service Coverage 25/3'],
    ...levelConfig.Municipality,
    visible: false,
  },
  {
    ...themeConfig.Competition,
    ...levelConfig.Municipality,
    visible: false,
  },
  {
    ...themeConfig['Number of Providers'],
    ...levelConfig.Municipality,
    visible: false,
  },
  {
    ...themeConfig['Maximum Speed'],
    ...levelConfig.Municipality,
    visible: false,
  },
  {
    ...themeConfig['Federal Funding'],
    ...levelConfig.Municipality,
    visible: false,
  },

  {
    ...themeConfig['Service Coverage 100/20'],
    ...levelConfig.County,
    visible: false,
  },
  {
    ...themeConfig['Service Coverage 25/3'],
    ...levelConfig.County,
    visible: false,
  },
  {
    ...themeConfig.Competition,
    ...levelConfig.County,
    visible: false,
  },
  {
    ...themeConfig['Number of Providers'],
    ...levelConfig.County,
    visible: false,
  },
  {
    ...themeConfig['Maximum Speed'],
    ...levelConfig.County,
    visible: false,
  },
  {
    ...themeConfig['Federal Funding'],
    ...levelConfig.County,
    visible: false,
  },

  {
    title: 'Federal Funding Areas',
    tileUrl: '/tile/fedfund/{z}/{x}/{y}',
    geometryType: 'polygon',
    ...fedFundingConfig,
    visible: false,
  },

  {
    title: 'Locations - Served',
    tileUrl: '/tile/location_served/{z}/{x}/{y}',
    geometryType: 'point',
    ...locationConfig.served,
    visible: true,
    minZoom: 15,
  },
  {
    title: 'Locations - Underserved',
    tileUrl: '/tile/location_underserved/{z}/{x}/{y}',
    geometryType: 'point',
    ...locationConfig.underserved,
    visible: true,
    minZoom: 15,
  },
];
